export default __webpack_public_path__ + "static/media/category.d8964750.svg";